import Section from '@/components/atomic/molecules/Section'
import Text from '@/components/atomic/atoms/Text'
import SocialIcons from './social-icons'
import { useTranslation } from '@/lang'
import { getFooterData } from '@/components/atomic/templates/Screen/screenData'
import { useLocales } from '@/shared/hooks/useLocales'

interface Props {
  onWeChatClick: () => void
}

const CompanyInfo = ({ onWeChatClick }: Props) => {
  const { t } = useTranslation()
  const { locale } = useLocales()

  const footerData = getFooterData(locale, t)

  return (
    <>
      <Section padding={0} hasDivider={false}>
        <p className="pt-2 pb-0 whitespace-pre-line text-[12px] leading-[16px]" style={{ color: '#888888' }}>
          {footerData.description}
        </p>
        <Text type="caption2" color="#888888" element="address">
          {footerData.address}
        </Text>
      </Section>

      <div className="my-6 whitespace-pre-line">
        <Text type="caption2" color="#888888">
          {footerData.aboutTransaction}
        </Text>
      </div>

      <SocialIcons iconLink={footerData.iconLink} onWeChatClick={onWeChatClick} />

      <Section padding={0} hasDivider={false}>
        <Text type="caption2" color="#666666" element="p">
          {footerData.copyright}
        </Text>
      </Section>
    </>
  )
}

export default CompanyInfo
